import React, { useRef, useState, useEffect } from "react";
import TextAreaValidator from "../components/partial/TextAreaValidator";
import { ValidatorForm } from "react-form-validator-core";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Loader from "../components/utils/Loader";
import TextValidator from "../components/partial/TextValidator";
import { contactus } from "../components/actions/auth";
import DashboardLayout from "../components/layouts/DashboardLayout";

function Contact() {
  const invalidDomains = [
    "mailinator",
    "cwmxc",
    "horsgit",
    "maildrop",
    "explodemail",
    "stresspc",
    "anonaddy",
  ];

  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
   const code = sessionStorage.getItem("code");

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    email: "",
    mobileNumber: "",
    description: "",
    merchantCode: code,
    createdAt: "",
    CompanyName:"test"
  });


  const { name, email, mobileNumber, description } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, ...{ [e.target.name]: e.target.value } });
  };

  // Email validation rule
  useEffect(() => {
    const validateEmail = (email) => {
      const domainPattern = invalidDomains.join("|");
      const regexPattern = `^(?!.*@(${domainPattern})\\b)([a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`;
      const regex = new RegExp(regexPattern);
      return regex.test(email);
    };
    ValidatorForm.addValidationRule("validEmail", (value) => validateEmail(value));
  }, [email]);

  // Name validation
  useEffect(() => {
    const validateName = (name) => /^[A-Za-z\s]*$/.test(name);
    ValidatorForm.addValidationRule("validName", (value) => validateName(value));
  }, [name]);

  // Description allowed characters
  useEffect(() => {
    const validateName = (name) =>
      /^[A-Za-z\s&,$,%,*,@,!,.,,,]*$/.test(name);
    ValidatorForm.addValidationRule("validNameData", (value) =>
      validateName(value)
    );
  }, [description]);

  // Description length rules
  useEffect(() => {
    ValidatorForm.addValidationRule("minimumlength", (value) => {
      return !(value.length > 0 && value.length < 50);
    });
    ValidatorForm.addValidationRule("maximumlength", (value) => {
      return value.length <= 500;
    });
  }, [description]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await contactus(formData);

    if (response.message === "success") {
      setLoading(false);
      swal({
        position: "center",
        icon: "success",
        title:
          "Thank you! Your message has been sent successfully. We will get back to you shortly.",
        timer: 5000,
      });

      setFormData({
        id: 0,
        name: "",
        email: "",
        mobileNumber: "",
        description: "",
        merchantCode: "",
        createdAt: "",
      });
    } else {
      swal({
        title: "Oops!",
        text: response.message,
        icon: "error",
        button: "Oh no!",
      });
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      {loading && <Loader />}

      <div className="min-h-screen flex flex-col items-center justify-start py-10 px-4">
        {/* Title */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-6">
          Contact Us
        </h1>

        {/* Card */}
        <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-xl">
          <ValidatorForm ref={formRef} onSubmit={(e) => onSubmit(e)}>
            {/* Name */}
            <div className="mb-4">
              <TextValidator
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Name"
                name="name"
                maxLength="50"
                value={name}
                onChange={onChange}
                validators={["required", "trim", "validName"]}
                errorMessages={[
                  "Please enter your name",
                  "Enter valid Name",
                  "Enter valid Name",
                ]}
              />
            </div>

            {/* Email */}
            <div className="mb-4">
              <TextValidator
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Email"
                name="email"
                maxLength="50"
                type="email"
                value={email}
                onChange={onChange}
                validators={["required", "validEmail"]}
                errorMessages={[
                  "Please enter your email",
                  "Enter valid email",
                ]}
              />
            </div>

            {/* Mobile Number */}
            <div className="mb-4">
              <TextValidator
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Contact Number"
                name="mobileNumber"
                maxLength="50"
                value={mobileNumber}
                onChange={onChange}
                validators={[
                  "required",
                  "matchRegexp:^(?!\\d*(\\d)\\1{7,}|0123456789|1234567890)\\d{10,15}$",
                ]}
                errorMessages={[
                  "Please enter your contact number",
                  "Please enter a valid number",
                ]}
              />
            </div>

            {/* Description */}
            <div className="mb-4">
              <TextAreaValidator
                placeholder="Details about your project"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 h-32 focus:ring-2 focus:ring-blue-500"
                name="description"
                value={description}
                onChange={onChange}
                validators={["required", "minimumlength", "maximumlength"]}
                errorMessages={[
                  "Please enter details about your project",
                  "Minimum length should be 50 characters",
                  "Maximum length should be 500 characters",
                ]}
              />
            </div>

            {/* Submit Button */}
            <div className="text-center mt-6">
              <button
                className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow-md transition"
                type="submit"
              >
                Submit
              </button>
            </div>
          </ValidatorForm>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default Contact;
